import $ from 'jquery';

function initGiftPopup() {
    const $popups = $('.js-gift-popup');
    const $customAmountInput = $('#customAmount');
    const $otherRadioButton = $('input[type=radio][name=selectAmount][value=other]');
    const $customAmountContainer = $('.gift-initiator__price-picker-other');

    function hideAllPopups() {
        $popups.stop(true, true).fadeOut('fast').attr('aria-hidden', 'true');
    }

    function showPopup(popupId) {
        hideAllPopups();
        const $popup = $(popupId);
        if ($popup.length) {
            $popup.stop(true, true).fadeIn('fast').attr('aria-hidden', 'false');
        }
    }

    function toggleCustomAmountClass() {
        if ($otherRadioButton.is(':checked')) {
            $customAmountContainer.addClass('active');
        } else {
            $customAmountContainer.removeClass('active');
        }
    }

    $customAmountInput.on('focus', function() {
        showPopup('#popup-custom');
    });

    $('input[type=radio][name=selectAmount]').on('change', function() {
        const $radioButton = $(this);
        const $trigger = $radioButton.closest('.js-gift-popup-toggle');
        $trigger.attr('aria-expanded', true);
        const popupId = $trigger.data('popup');
        showPopup(`#${popupId}`);
        toggleCustomAmountClass();
    });

    $('.gift-initiator__popup-close-button').on('click', function() {
        hideAllPopups();
    });

    toggleCustomAmountClass();
}

export default initGiftPopup;
